<div class="metadata-creation-dialog">
    <h2 mat-dialog-title>Create New</h2>

    <mat-dialog-content>
        <form #form="ngForm">
            <metadata-panel ngModelGroup="createEntity" fxFill *ngIf="!loading" [model]="entity"
                            [metadata]="metadata"></metadata-panel>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="column" fxLayoutAlign="center end">
        <forge-linear-progress *ngIf="loading || saving"></forge-linear-progress>
        <command-bar [commands]="commands" attr.telemetry="CreateEntity-{{type}}"></command-bar>
    </mat-dialog-actions>
</div>